const $selectorBack = $('#selector-back');
const $steps = $('.step');
const $questions = $('.question');
const $results = $('.product-selector__results');
const $cards = $results.find('.product-card');
const $count = $('.result-count');
const $notFoundMessage = $('.product-selector__not-found');

var updateSelectorBack = function () {
    if ($('.question.active').index() === 0) {
        $selectorBack.removeClass('enabled');
    } else {
        $selectorBack.addClass('enabled');
    }
};

var getCurrentConditions = function () {
    var conditions = [];
    let $answers = $('.answer.selected');
    // update current conditions
    $answers.each(function () {
        conditions.push($(this).data('value'));
    });
    return conditions;
};

var setEnabled = function ($el) {
    let currentConditions = getCurrentConditions();
    let conditions = $el.data('conditions');
    let isEnabled = true; // default for non-conditional elements
    if (conditions) {
        conditions = conditions.split(',');
        for (let index = 0; index < currentConditions.length; index++) {
            if (typeof conditions[index] !== 'undefined' && conditions[index] !== currentConditions[index]) {
                // typeof check makes sure "summer,harvest" question condition will still be enabled for "summer,harvest,hay" current condition
                // if we have an index for the current length, but it doesn't match the current condition, then exclude this element
                isEnabled = false;
                break;
            }
        }
    }
    if (isEnabled) {
        $el.addClass('enabled');
    }
};

var enableQuestions = function () {
    // enable/disable questions
    $questions.removeClass('enabled');
    $questions.each(function () {
        setEnabled($(this));
    });
    // do the same for steps
    // $steps.removeClass('enabled');
    // $steps.each(function(){
    //   setEnabled($(this));
    // });
};

var populateResults = function () {
    let currentConditions = getCurrentConditions();
    let key = currentConditions.join(',');
    let count = 0;
    $cards.each(function () {
        if ($(this).data('selector-rule') === key) {
            count++;
            $(this).show();
        } else {
            $(this).hide();
        }
    });

    if (count === 0) {
        $notFoundMessage.show();
        $count.hide();
    } else {
        let resultsCountLabel = count === 1 ? 'product' : 'products';
        $count.html(count + ' ' + resultsCountLabel);
        $notFoundMessage.hide();
    }
    $results.show();
};

$('.product-selector .answer').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.answers').find('.answer').removeClass('selected');
    $(this).addClass('selected');
    window.setTimeout(() => {
        $('body').trigger('question-answered');
    }, 500);
});

$('body').on('question-answered', function () {

    // hide results when already shown and a new conditional question is asked
    $results.hide();

    // update the questions required for the current answer path
    enableQuestions();

    // maybe show the results
    if ($('.answer.selected').length == $('.question.enabled').length) {
        populateResults();
        // $steps.eq(currentIndex).addClass('completed');
    } else {
        // move to the next question
        let $currentQuestion = $('.question.active');
        $currentQuestion.removeClass('active');
        $currentQuestion.nextAll('.question.enabled').first().addClass('active');

        // mark step as completed
        // $steps.eq(currentIndex).removeClass('active').addClass('completed');

        // update active step
        // $steps.eq(currentIndex + 1).addClass('active');
    }
    updateSelectorBack();
});

$selectorBack.on('click', function (e) {
    e.preventDefault();
    let $currentQuestion = $('.question.active');

    // hide results
    $results.hide();

    // remove the current answer
    $currentQuestion.find('.answer.selected').removeClass('selected');
    // $steps.eq(currentIndex).removeClass('active').removeClass('completed');

    // move to the previous question
    $currentQuestion.removeClass('active');
    $currentQuestion.prevAll('.question.enabled').first().addClass('active');

    // remove answer on new current question to force a new answer
    $('.question.active').find('.answer.selected').removeClass('selected');

    // update active step
    // $steps.eq($currentQuestion.index()).addClass('active').removeClass('completed');

    enableQuestions();
    updateSelectorBack();
});


